const frameFile =
  process.env.NODE_ENV === 'development' ? `/data/18799656.json` : `/src/data/18799656.json`;
const lensesFile =
  process.env.NODE_ENV === 'development' ? `/data/18852442.json` : `/src/data/18852442.json`;
// const cartFile = process.env.NODE_ENV === 'development' ? `/data/cartMock.json` : `/src/data/cartMock.json`;

const readFile = async (file: string): Promise<any> => {
  const data = await fetch(file);
  const dataJson = await data.json();

  return new Promise((resolve, reject) => {
    if (dataJson) resolve({ data: dataJson });
    reject();
  });
};

/* MOCK CART */
/*export const getMockCart = async () => {
    return await readFile(cartFile);
}*/

/* MOCK FRAME PROPERTIES */
export const getMockFrameProperties = async () => {
  return await readFile(frameFile).then(res => res.data);
};

/* MOCK LENSES PROPERTIES */
export const getMockLensesProperties = async () => {
  return await readFile(lensesFile).then(res => res.data);
};
